/**
 * Layout
 * @module components/Layout
 */

import { Content } from './Layout.styles';
import { ReactNode } from 'react';
import clsx from 'clsx';

type LayoutProps = {
	backgroundColor?: string;
	className?: string;
	childClassName?: string;
	children: ReactNode;
};

const Layout = ({
	backgroundColor,
	className,
	children,
	childClassName,
}: LayoutProps) => {
	return (
		<div
			className={clsx(
				'block overflow-hidden',
				backgroundColor ? `bg-${backgroundColor}` : 'bg-transparent',
				className
			)}
		>
			<Content className={childClassName}>{children}</Content>
		</div>
	);
};

export default Layout;
